import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import images from "./../../../images";
import {
  useGetUserInfoQuery,
  useGetUnreadInboxCountQuery,
  useGetUnreadQuestHistoryCountQuery,
} from "./../../../services/apiSlice";

const CoinBadge = () => {
  const navigate = useNavigate();
  const { id: locationId } = useParams();
  const [searchParams] = useSearchParams();

  const code = searchParams.get("code");

  const { unreadCount, questHistoryCount } = useSelector(
    (state) => state.common,
  );
  const accessToken =
    localStorage.getItem("accessToken") ||
    sessionStorage.getItem("accessToken");
  const refreshToken =
    localStorage.getItem("refreshToken") ||
    sessionStorage.getItem("refreshToken");
  const isAuthenticated = accessToken || refreshToken;

  const { data: userInfo } = useGetUserInfoQuery(undefined, {
    skip: !isAuthenticated,
  });

  useGetUnreadInboxCountQuery(undefined, {
    skip: !isAuthenticated,
    skipPollingIfUnfocused: true,
    pollingInterval: 60000,
  });

  useGetUnreadQuestHistoryCountQuery(undefined, {
    skip: !isAuthenticated,
    skipPollingIfUnfocused: true,
    pollingInterval: 60000,
  });

  useEffect(() => {
    if (userInfo?.data?.id) {
      localStorage.setItem("customUserId", userInfo.data.id);
      localStorage.setItem("userInfo", JSON.stringify(userInfo.data));
    }
  }, [userInfo]);

  const handleSignIn = () => {
    navigate(
      "/sign-in?from=qrcode&location_id=" +
        locationId +
        (code ? "&code=" + code : ""),
    );
  };

  const handleSignUp = () => {
    navigate(
      "/register?from=qrcode&location_id=" +
        locationId +
        (code ? "&code=" + code : ""),
    );
  };

  return accessToken ? (
    <div
      className="h-[27px] px-3 bg-primary rounded-md flex items-center gap-1.5 cursor-pointer relative"
      onClick={() => navigate("/profile")}
    >
      <img className="size-[15px]" src={images.v6RallyCoin} alt="" />
      <p className="text-white text-lg leading-[21px] font-bold">
        {userInfo?.data?.token ? parseInt(userInfo?.data?.token) : 0}
      </p>
      {(!!unreadCount || !!questHistoryCount) && (
        <span className="size-5 bg-destructive rounded-full border-2 border-white absolute top-0 -right-[10px] -translate-y-1/2" />
      )}
    </div>
  ) : (
    <div className="flex flex-row text-primary text-sm font-bold gap-1">
      <span className="cursor-pointer" onClick={handleSignIn}>
        Sign Up
      </span>
      <span>/</span>
      <span className="cursor-pointer" onClick={handleSignUp}>
        Log in
      </span>
    </div>
  );
};

export default CoinBadge;
